import type {HistoryActionContext} from './historyActionContext';
import type {HistoryStack} from 'components/customer/RoomPlanner/types';

export const undoCabinetUpdate = async (
    historyItem: HistoryStack,
    targetIndex: number,
    ctx: HistoryActionContext
): Promise<void> => {
    if (historyItem.data?.undoAction) {
        await historyItem.data.undoAction({
            historyItem,
            dispatch: ctx.dispatch,
            historyIndex: targetIndex,
            cabinetGroupListRef: ctx.cabinetGroupListRef,
        });
    }
    ctx.setPreviousHistoryIndex(targetIndex);
};

export const redoCabinetUpdate = async (
    historyItem: HistoryStack,
    targetIndex: number,
    ctx: HistoryActionContext
): Promise<void> => {
    if (historyItem.data?.redoAction) {
        try {
            await historyItem.data.redoAction({
                historyItem,
                dispatch: ctx.dispatch,
                historyIndex: targetIndex,
                cabinetGroupListRef: ctx.cabinetGroupListRef,
            });
        } catch {
            // ignore
        }
    }
    await ctx.setNextHistoryIndex(targetIndex, ctx.targetIndex);
};
